<div class="m3">
    <app-top-schools-report></app-top-schools-report>
    <app-admin-accounts-report></app-admin-accounts-report>
    <app-staff-accounts-report></app-staff-accounts-report>
    <app-report-with-dates-include-no-activity-old></app-report-with-dates-include-no-activity-old>
    <app-report-with-dates></app-report-with-dates>
    <app-generic-report></app-generic-report>
    <app-aggregate-license-report></app-aggregate-license-report>
    <app-scrub-org></app-scrub-org>
</div>